module.exports = __webpack_public_path__ + "img/m_award_img04.bfe3a547.jpg";